<template>
  <div style="padding-left: 10px;padding-right: 10px;min-width: 200px;max-width: 300px;max-height: 250px;overflow: auto">
    <div class="col-xs-12">
      <span>Filter by Affiliation type</span>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div class="row">
        <div class="col-xs-6">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="feedFilter"> Select All</a>
        </div>
        <div class="col-xs-6 text-right">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="clearFilter"> Clear All</a>
        </div>
      </div>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div v-for="(affiliationType, key) in affiliationsType" :key="key" style="padding-top: 10px">
        <div class="checkbox checkbox-info checkbox-inline">
          <input :id="uniqId + 'checkbox-affiliationType-' + affiliationType.name" type="checkbox"
                 v-on:change="affiliationTypeSelected(affiliationType)" v-bind:checked="checked(affiliationType)"
                 :disabled="affiliationType.nb === 0">
          <label :for="uniqId + 'checkbox-affiliationType-' + affiliationType.name">
            <template v-if="affiliationType.name === true">
            Univ / Research inst. ({{affiliationType.nb}})
            </template>
            <template v-else>
              Company ({{affiliationType.nb}})
            </template>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .pe-ul > li {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pe-ul > li > i{
    color: #62cb31;
    font-weight: bold;
  }

  .pe-ul > li > span{
    font-size: 14px;
    font-weight: normal;
  }

</style>
<script>

export default {
  components: {},
  props: ['affiliationsType', 'affiliationsTypeSelected'],
  name: 'AffiliationTypeBox',
  data () {
    return {
      uniqId: ''
    }
  },
  methods: {
    checked: function (affiliationType) {
      if (this.affiliationsTypeSelected.length !== 0) {
        let tmpAffiliationTypeSelected = this.affiliationsTypeSelected.find((affiliationTypeSelected) => {
          return affiliationTypeSelected.name === affiliationType.name
        })
        if (typeof tmpAffiliationTypeSelected !== 'undefined') {
          return true
        }
      }
      return false
    },
    affiliationTypeSelected: function (affiliationType) {
      let index = this.affiliationsTypeSelected.map((e) => {
        return e.name
      }).indexOf(affiliationType.name)

      if (index === -1) {
        this.affiliationsTypeSelected.push(affiliationType)
      } else {
        this.affiliationsTypeSelected.splice(index, 1)
      }
    },
    clearFilter: function (event) {
      this.affiliationsTypeSelected.splice(0, this.affiliationsTypeSelected.length)
      event.preventDefault()
    },
    feedFilter: function (event) {
      this.clearFilter(event)

      this.affiliationsType.forEach((affiliationType) => {
        this.affiliationsTypeSelected.push(affiliationType)
      })
      event.preventDefault()
    }

  },
  beforeMount () {
    this.uniqId = Math.random().toString()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/AffiliationTypeBox.vue